import React from 'react';

export default () => (
  <svg width={19} height={19} viewBox="0 0 19 19">
    <path
      d="M9 8h2.8a.2.2 0 0 0 .2-.2V6.2a.2.2 0 0 0-.2-.2H4.2a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2H7v6.8c0 .11.09.2.2.2h1.6a.2.2 0 0 0 .2-.2V8zm3.2 6h.8v-.8c0-.11.09-.2.2-.2h.8v1h.8c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2h-2.6a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2zm-.2-2.2v-.6c0-.11.09-.2.2-.2h2.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H14v-1h-1.8a.2.2 0 0 1-.2-.2z"
      fill="currentColor"
    />
  </svg>
);
